import './linkPreview.scss';

export const linkPreviewTemplate = (model) => {
	const { msg, message_id } = model;

	const linkTag = msg.replace(
		/<a /g,
		`<a target="_blank" class="engt-tab-selectable" data-link-preview-id=${message_id} `
	);

	/* html */
	const wrapper = `<span class="engt-link">${linkTag}</span>`;

	return wrapper;
};
